import useCreateInstance from '../../hooks/useCreateAxiosInstance';
import { env } from '../../utils';
import { getMetaApiFetchers } from './getMetaApiFetchers';

const useMetaApiInstance = () => {
  const metaEndpoint = env.KC_META_ENDPOINT || '';

  const axiosInstance = useCreateInstance({
    baseURL: metaEndpoint,
    withRequestId: env.KC_PERFORMANCE_LOGGING === 'true',
    overrideAxiosRequestConfig: {
      withCredentials: true,
    },
  });
  return getMetaApiFetchers(axiosInstance);
};

export default useMetaApiInstance;
